import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Save, Code, Eye, ArrowLeft } from "lucide-react";

/**
 * DesignerHeader — top toolbar (back / template name / element count /
 * Preview / Export EJS / Save buttons). Stateless presentational component.
 */
export function DesignerHeader({
  templateName,
  onTemplateNameChange,
  totalElements,
  isSaving,
  onPreview,
  onExportEjs,
  onSave,
}) {
  const navigate = useNavigate();
  return (
    <header className="h-14 bg-white border-b border-gray-200 flex items-center px-4 gap-3 shrink-0 z-10">
      <Button
        variant="ghost"
        size="icon"
        data-testid="back-to-templates-btn"
        onClick={() => navigate("/")}
        className="h-8 w-8"
      >
        <ArrowLeft className="w-4 h-4" />
      </Button>
      <div className="w-px h-6 bg-gray-200" />
      <Input
        value={templateName}
        onChange={(e) => onTemplateNameChange(e.target.value)}
        data-testid="template-name-input"
        className="max-w-[260px] h-8 text-sm font-heading font-semibold border-transparent hover:border-gray-300 focus:border-blue-400"
      />
      <span className="text-[10px] text-gray-400">{totalElements} elements</span>
      <div className="flex-1" />
      <Button
        variant="outline"
        size="sm"
        data-testid="preview-btn"
        onClick={onPreview}
        className="gap-2 h-8"
      >
        <Eye className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Preview</span>
      </Button>
      <Button
        variant="outline"
        size="sm"
        data-testid="export-ejs-btn"
        onClick={onExportEjs}
        className="gap-2 h-8"
      >
        <Code className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Export EJS</span>
      </Button>
      <Button
        size="sm"
        data-testid="save-template-btn"
        onClick={onSave}
        disabled={isSaving}
        className="gap-2 h-8"
      >
        <Save className="w-3.5 h-3.5" />
        {isSaving ? "Saving..." : "Save"}
      </Button>
    </header>
  );
}
